import { type FC } from "react";

import { HorizontalBarChart } from "../../lens-insights/components/charts/horizontal-bar-chart";
import { ChartCard } from "../../lens-insights/components/shared";
import { type CountriesStatsItem } from "../../lens-insights/models";

interface HorizontalBarChartCardProps {
    loading?: boolean;
    className?: string;
    title?: string;
    stats?: CountriesStatsItem[];
}

export const HorizontalBarChartCard: FC<HorizontalBarChartCardProps> = ({
    loading = false,
    stats,
    title,
    className,
}) => {
    return (
        <ChartCard title={title} className={className}>
            <HorizontalBarChart stats={stats ?? []} loading={loading} />
        </ChartCard>
    );
};
